import { useDispatch } from "react-redux";
import useModal from "hooks/useModal";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { patchupdateReservation } from "redux/actions/reservationAction";
import AllotVehicleModal from "pages/operation/allRides/AllotVehicleModal";
import CancelRegistrationModal from "pages/operation/cancelRegistrationModal/CancelRegistrationModal";
import crossBtn from "assets/images/CrossBtn.svg";
import ReAllot from "assets/images/Reallot.svg";
import PrintDutySlip from "assets/images/PrintDuty.svg";
import editmore from "assets/images/moreEditIcon.svg";

const CommonTableDialog = (props) => {
  const { open, setOpen, menuData } = props;
  const { open: visible, toggle: setVisible } = useModal();
  const { open: allotModal, toggle: setAllotModal } = useModal();

  const openDialog = Boolean(open);
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (value) => {
    if (value.label === "Vip") {
      const payloadData = {
        id: props?.data?.id,
        formData: {
          isVip: props?.data?.isVip ? false : true,
          type: props?.data?.type,
        },
      };
      dispatch(patchupdateReservation(payloadData, "details"));
      handleClose();
    } else if (value.label === "Cancel Duty") {
      setVisible();
    } else if (value.label === "Re-Allot") {
      setAllotModal();
    }
    handleClose();
  };

  const moreIconSrc = (value) => {
    switch (value?.toLowerCase()) {
      case "edit":
        return editmore;
      case "cancel duty":
        return crossBtn;
      case "print duty slip":
        return PrintDutySlip;
      case "re-allot":
        return ReAllot;
      default:
        return;
    }
  };

  return (
    <Grid
      container
      className="commonFilter widthFit"
      alignItems={"center"}
      role="presentation"
    >
      <Menu
        id="basic-menu"
        anchorEl={open}
        open={openDialog}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        className="br20 detailsMenu"
      >
        {menuData &&
          menuData?.map((menu, index) => (
            <MenuItem
              onClick={() => handleClick(menu)}
              key={index}
              className="menuList"
            >
              {menu.label === "Vip" && <Box className="detailsVipCheckbox">
                <FormControlLabel
                  control={
                    <Checkbox name="Vip" defaultChecked={props?.data?.isVip} />
                  }
                  label={
                    <Typography variant="body3" className="colorPrimary">
                      {menu.label === "Vip" && menu.label}
                    </Typography>
                  }
                />
              </Box>}

              {moreIconSrc(menu?.label)?.length > 0 && (
                <span className="mr10 alignItem">
                  <img
                    src={moreIconSrc(menu?.label)}
                    alt={menu?.label}
                    className="width20"
                  />
                </span>
              )}

              <Typography
                variant="body3"
                className="fw400 textBlack"
              >
                {menu.label !== "Vip" && menu.label}
              </Typography>
            </MenuItem>
          ))}
      </Menu>
      <AllotVehicleModal
        open={allotModal}
        toggle={setAllotModal}
        tripDetails={props?.data}
        page={"details"}
      />

      {visible && <CancelRegistrationModal
        page={"details"}
        open={visible}
        toggle={setVisible}
        reservationData={props?.data}
      />}
    </Grid>
  );
};

export default CommonTableDialog;
